import React, {useContext, useEffect} from "react";
import '../forms/UserDetailsForm/index.scss'
import {forms} from "../forms";
import {TravelQuotation} from "../../../model/quotation";
import {Stage} from "../../../api/model/scenario";
import { StepProps } from "../../QuotationForm/step-props";
import {TravelStepContext} from "../../../contexts/TravelStepContext";
import {TravelScenarioContext} from "../../../contexts/TravelScenatioContext";
import Cart from "../Cart";
import {useMediaQuery} from "@material-ui/core";
import {ITravelQuotationContext, TravelQuotationContext} from "../../../contexts/TravelQuotationContext";

export const TravelUserDetailsStep = ({step}: StepProps) => {
    const {quotation, setCurrentStep} = useContext<ITravelQuotationContext>(TravelQuotationContext);
    const {currentStep, backStageHandler} = useContext(TravelScenarioContext);
    const {nextStepListener, backStepListener} = useContext(TravelStepContext);
    const isMobile = useMediaQuery('(max-width: 1023px)');

    useEffect(() => {
        setCurrentStep("travel_online_00002")
    }, [])

    const onFormSubmit = (submittedQuotation: TravelQuotation) => {
        nextStepListener(submittedQuotation);
    };

    const backStepHandler = (quotation: any) => {
        backStepListener(quotation, (stage: Stage) => {
            const currentStepIndex = stage.steps.indexOf(currentStep);
            let newPreviousStep = currentStep;
            if (currentStepIndex === 0) {
                if (newPreviousStep && (newPreviousStep.code === "travel_online_00002")) {
                    backStageHandler(quotation);
                }
            }
        });
    };

    return (
        <>
            <div className={'displayFlex'}>
                {step.forms.map(form => {
                    return React.createElement(forms[form.code], {
                        key: form.code,
                        onFormSubmit,
                        backStepHandler
                    })
                })}
                {!isMobile ? <Cart isMobile={isMobile}
                                   selectedPackage={'Оптимальний'}
                                   personsCount={quotation.travelWebContract.touristCount}
                                   cost={quotation.travelWebContract.premium}
                                   total={quotation.totalPremium}
                /> : <></>}
            </div>


        </>
    );
};